import { FDealType } from '../../../../packages/JsonQuery';
import { IDealType } from '../types';

export const OPTIONS: IDealType[] = [
  { label: 'Купить', value: FDealType.Sale },
  { label: 'Снять', value: FDealType.RentLongterm },
  { label: 'Посуточно', value: FDealType.RentDaily },
];
